export default {
    "menuList": {
        "en": [
            {
                "url": "/curriculum/guide",
                "menuTitle": "Curriculum Guide"
            },
            {
                "url": "/curriculum/prekinder",
                "menuTitle": "Pre Kindergarten"
            },
            {
                "url": "/curriculum/kinder",
                "menuTitle": "Kindergarten"
            },
            {
                "url": "/curriculum/firstgrade",
                "menuTitle": "1st Grade"
            },
            {
                "url": "/curriculum/secondgrade",
                "menuTitle": "2nd Grade"
            },
            {
                "url": "/curriculum/levelofdailyadventures",
                "menuTitle": "Level of Daily Adventures"
            },
            {
                "url": "/curriculum/games/countingandcardinality",
                "menuTitle": "The Games",
                "realPath": "games",
                "submenu": [
                    {
                        "url": "/curriculum/games/countingandcardinality",
                        "menuTitle": "Counting & Cardinality"
                    },
                    {
                        "url": "/curriculum/games/numberoperations",
                        "menuTitle": "Number Operations"
                    },
                    {
                        "url": "/curriculum/games/mathaticalresoning",
                        "menuTitle": "Mathematical Reasoning"
                    },
                    {
                        "url": "/curriculum/games/timeandmoney",
                        "menuTitle": "Time and Money"
                    },
                    {
                        "url": "/curriculum/games/geometry",
                        "menuTitle": "Geometry"
                    },
                    {
                        "url": "/curriculum/games/measurementanddata",
                        "menuTitle": "Measurement and Data"
                    }
                ]
            },
            {
                "url": "/curriculum/missions/prekinder",
                "menuTitle": "The Missions",
                "realPath": "missions",
                "submenu": [
                    {
                        "url": "/curriculum/missions/prekinder",
                        "menuTitle": "Pre Kindergarten"
                    },
                    {
                        "url": "/curriculum/missions/kinder",
                        "menuTitle": "Kindergarten"
                    },
                    {
                        "url": "/curriculum/missions/firstgrade",
                        "menuTitle": "1st Grade"
                    },
                    {
                        "url": "/curriculum/missions/secondgrade",
                        "menuTitle": "2nd Grade"
                    }
                ]
            }
        ],
        "ko": [
            {
                "url": "/curriculum/guide",
                "menuTitle": "토도수학 교육과정 가이드"
            },
            {
                "url": "/curriculum/prekinder",
                "menuTitle": "유아 수학"
            },
            {
                "url": "/curriculum/kinder",
                "menuTitle": "유치원"
            },
            {
                "url": "/curriculum/firstgrade",
                "menuTitle": "1학년",
                "content_type": "typeA"
            },
            {
                "url": "/curriculum/secondgrade",
                "menuTitle": "2학년"
            },
            {
                "url": "/curriculum/levelofdailyadventures",
                "menuTitle": "오늘의 모험 단계"
            },
            {
                "url": "/curriculum/games/countingandcardinality",
                "menuTitle": "게임",
                "realPath": "games",
                "submenu": [
                    {
                        "url": "/curriculum/games/countingandcardinality",
                        "menuTitle": "수 세기"
                    },
                    {
                        "url": "/curriculum/games/numberoperations",
                        "menuTitle": "연산"
                    },
                    {
                        "url": "/curriculum/games/mathaticalresoning",
                        "menuTitle": "수학적 사고"
                    },
                    {
                        "url": "/curriculum/games/timeandmoney",
                        "menuTitle": "시간과 동전"
                    },
                    {
                        "url": "/curriculum/games/geometry",
                        "menuTitle": "도형"
                    },
                    {
                        "url": "/curriculum/games/measurementanddata",
                        "menuTitle": "측정과 자료"
                    }
                ]
            },
            {
                "url": "/curriculum/missions/prekinder",
                "menuTitle": "미션 모드",
                "realPath": "missions",
                "submenu": [
                    {
                        "url": "/curriculum/missions/prekinder",
                        "menuTitle": "유아 수학"
                    },
                    {
                        "url": "/curriculum/missions/kinder",
                        "menuTitle": "유치원"
                    },
                    {
                        "url": "/curriculum/missions/firstgrade",
                        "menuTitle": "1학년"
                    },
                    {
                        "url": "/curriculum/missions/secondgrade",
                        "menuTitle": "2학년"
                    }
                ]
            }
        ],
        "cn": [
            {
                "url": "/curriculum/guide",
                "menuTitle": "都都数学<br>内容说明"
            },
            {
                "url": "/curriculum/prekinder",
                "menuTitle": "Level A"
            },
            {
                "url": "/curriculum/kinder",
                "menuTitle": "Level B/C"
            },
            {
                "url": "/curriculum/firstgrade",
                "menuTitle": "Level D/E",
                "content_type": "typeA"
            },
            {
                "url": "/curriculum/secondgrade",
                "menuTitle": "Level F/G"
            },
            {
                "url": "/curriculum/levelofdailyadventures",
                "menuTitle": "每日探险的级别"
            },
            {
                "url": "/curriculum/games/countingandcardinality",
                "menuTitle": "游戏",
                "realPath": "games",
                "submenu": [
                    {
                        "url": "/curriculum/games/countingandcardinality",
                        "menuTitle": "计数与基数"
                    },
                    {
                        "url": "/curriculum/games/numberoperations",
                        "menuTitle": "运算"
                    },
                    {
                        "url": "/curriculum/games/mathaticalresoning",
                        "menuTitle": "数学推理"
                    },
                    {
                        "url": "/curriculum/games/timeandmoney",
                        "menuTitle": "时间和金钱"
                    },
                    {
                        "url": "/curriculum/games/geometry",
                        "menuTitle": "几何"
                    },
                    {
                        "url": "/curriculum/games/measurementanddata",
                        "menuTitle": "测量和数据"
                    }
                ]
            },
            {
                "url": "/curriculum/missions/prekinder",
                "menuTitle": "任务",
                "realPath": "missions",
                "submenu": [
                    {
                        "url": "/curriculum/missions/prekinder",
                        "menuTitle": "Level A"
                    },
                    {
                        "url": "/curriculum/missions/kinder",
                        "menuTitle": "Level B/C"
                    },
                    {
                        "url": "/curriculum/missions/firstgrade",
                        "menuTitle": "Level D/E"
                    },
                    {
                        "url": "/curriculum/missions/secondgrade",
                        "menuTitle": "Level F/G"
                    }
                ]
            }
        ],
        "ja": [
            {
                "url": "/curriculum/guide",
                "menuTitle": "トドさんすう教育過程ガイド"
            },
            {
                "url": "/curriculum/prekinder",
                "menuTitle": "幼児の算数"
            },
            {
                "url": "/curriculum/kinder",
                "menuTitle": "幼稚園"
            },
            {
                "url": "/curriculum/firstgrade",
                "menuTitle": "1ねんせい",
                "content_type": "typeA"
            },
            {
                "url": "/curriculum/secondgrade",
                "menuTitle": "2ねんせい"
            },
            {
                "url": "/curriculum/levelofdailyadventures",
                "menuTitle": "きょうのぼうけんのレベル"
            },
            {
                "url": "/curriculum/games/countingandcardinality",
                "menuTitle": "ゲーム",
                "realPath": "games",
                "submenu": [
                    {
                        "url": "/curriculum/games/countingandcardinality",
                        "menuTitle": "すうじとかぞえ"
                    },
                    {
                        "url": "/curriculum/games/numberoperations",
                        "menuTitle": "計算"
                    },
                    {
                        "url": "/curriculum/games/mathaticalresoning",
                        "menuTitle": "さんすうてきかんがえ"
                    },
                    {
                        "url": "/curriculum/games/timeandmoney",
                        "menuTitle": "時間とお金"
                    },
                    {
                        "url": "/curriculum/games/geometry",
                        "menuTitle": "図形"
                    },
                    {
                        "url": "/curriculum/games/measurementanddata",
                        "menuTitle": "測定と統計"
                    }
                ]
            },
            {
                "url": "/curriculum/missions/prekinder",
                "menuTitle": "ミッションモード",
                "realPath": "missions",
                "submenu": [
                    {
                        "url": "/curriculum/missions/prekinder",
                        "menuTitle": "幼児"
                    },
                    {
                        "url": "/curriculum/missions/kinder",
                        "menuTitle": "年長児"
                    },
                    {
                        "url": "/curriculum/missions/firstgrade",
                        "menuTitle": "1ねんせい"
                    },
                    {
                        "url": "/curriculum/missions/secondgrade",
                        "menuTitle": "2ねんせい"
                    }
                ]
            }
        ]
    },
    "contentType": {
        "prekinder": "typeA",
        "kinder": "typeA",
        "firstgrade": "typeA",
        "secondgrade": "typeA",
        "games": "typeD",
        "games_countingandcardinality": "typeB",
        "games_numberoperations": "typeB",
        "games_mathaticalresoning": "typeB",
        "games_timeandmoney": "typeB",
        "games_geometry": "typeB",
        "games_measurementanddata": "typeB",
        "missions": "typeD",
        "missions_prekinder": "typeC",
        "missions_kinder": "typeC",
        "missions_firstgrade": "typeC",
        "missions_secondgrade": "typeC",
        "levelofdailyadventures": "typeE"
    }
}



// WEBPACK FOOTER //
// ./src/text/curriculum/menu.js